import BookmarksScreen from './BookmarksScreen.js';
//holao
export default BookmarksScreen;
